import {TemplateActionTypes} from "../Actions/actionTypes";

const initialState = {
    templates: [],
    selectedTemplateId: null,
    filters: {
        section: null,
        creator: null,
        is_active: null
    },
    searchTerm: '',
    currentPage: 1,
    activeTab: 'available',
    editingTemplate: null,
    newTemplateName: '',
    error: ''
};

export const templateReducer = (state = initialState, action) => {
    switch (action.type) {
        case TemplateActionTypes.SET_TEMPLATES:
            return { ...state, templates: action.payload };

        case TemplateActionTypes.ADD_TEMPLATE:
            return {
                ...state,
                templates: [...state.templates, action.payload],
                selectedTemplateId: action.payload.id,
                newTemplateName: ''
            };

        case TemplateActionTypes.DELETE_TEMPLATE:
            const remaining = state.templates.filter(t => t.id !== action.payload);
            return {
                ...state,
                templates: remaining,
                selectedTemplateId:
                    state.selectedTemplateId === action.payload
                        ? remaining[0]?.id || null
                        : state.selectedTemplateId
            };

        case TemplateActionTypes.EDIT_TEMPLATE:
            return {
                ...state,
                templates: state.templates.map(t =>
                    t.id === action.payload.id ? { ...t, title: action.payload.title } : t
                ),
                editingTemplate: null
            };

        case TemplateActionTypes.SET_EDITING_TEMPLATE:
            return { ...state, editingTemplate: action.payload };

        case TemplateActionTypes.ADD_CRITERION:
            return {
                ...state,
                templates: state.templates.map(t =>
                    t.id === state.selectedTemplateId && !t.criteria.includes(action.payload)
                        ? { ...t, criteria: [...t.criteria, action.payload] }
                        : t
                )
            };

        case TemplateActionTypes.REMOVE_CRITERION:
            return {
                ...state,
                templates: state.templates.map(t =>
                    t.id === state.selectedTemplateId
                        ? { ...t, criteria: t.criteria.filter(id => id !== action.payload) }
                        : t
                )
            };

        case TemplateActionTypes.SET_SELECTED_TEMPLATE:
            return { ...state, selectedTemplateId: action.payload };

        case TemplateActionTypes.SET_ERROR:
            return {...state, error: action.payload};

        case TemplateActionTypes.SET_FILTERS:
            return { ...state, filters: action.payload, currentPage: 1 };

        case TemplateActionTypes.SET_SEARCH_TERM:
            return { ...state, searchTerm: action.payload, currentPage: 1 };

        case TemplateActionTypes.SET_PAGE:
            return { ...state, currentPage: action.payload };

        case TemplateActionTypes.SET_ACTIVE_TAB:
            return { ...state, activeTab: action.payload };

        case TemplateActionTypes.SET_NEW_TEMPLATE_NAME:
            return { ...state, newTemplateName: action.payload };

        case TemplateActionTypes.UPDATE_TEMPLATE :
            return {
                ...state,
                templates: state.templates.map(t =>
                    t.id === action.payload.id ? { ...t, ...action.payload } : t
                )
            };
        default:
            return state;
    }
};
